import React, { useState } from "react";
import { useUXContext } from "./UXContext";
import { defaultFilters, countries, categories, dateOptions, matchOptions } from "../constants";

export default function FilterBar({ filters, setFilters, onSearch }) {
  const { mode, setMode } = useUXContext();
  const [keywordInput, setKeywordInput] = useState("");

  const addKeyword = () => {
    const trimmed = keywordInput.trim();
    if (
      trimmed &&
      !filters.keywords.includes(trimmed) &&
      filters.keywords.length < 5
    ) {
      setFilters((prev) => ({ ...prev, keywords: [...prev.keywords, trimmed] }));
      setKeywordInput("");
    }
  };

  const removeKeyword = (kw) => {
    setFilters((prev) => ({
      ...prev,
      keywords: prev.keywords.filter((k) => k !== kw),
    }));
  };

  return (
    <div className="filterbar filterbar-fade-bottom">
      {/* Tabs (URL removed) */}
      <div className="tab-toggle">
        <button
          onClick={() => setMode("top")}
          className={`tab ${mode === "top" ? "active" : ""}`}
        >
          Top
        </button>
        <button
          onClick={() => setMode("detailed")}
          className={`tab ${mode === "detailed" ? "active" : ""}`}
        >
          Explore
        </button>
      </div>

      {/* Top Headlines Filters */}
      {mode === "top" && (
        <div className="input-row">
          <select
            value={filters.countries[0] || ""}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, countries: [e.target.value] }))
            }
            className="input-sm half left"
          >
            {countries.map((c) => (
              <option key={c.code} value={c.code}>
                {c.name}
              </option>
            ))}
          </select>

          <select
            value={filters.category}
            onChange={(e) =>
              setFilters((prev) => ({ ...prev, category: e.target.value }))
            }
            className="input-sm half right"
          >
            {categories.map((c) => (
              <option key={c} value={c}>
                {c.charAt(0).toUpperCase() + c.slice(1)}
              </option>
            ))}
          </select>
        </div>
      )}

      {/* Detailed Search Filters */}
      {mode === "detailed" && (
        <>
          <div className="input-row">
            <select
              value={filters.countries[0] || ""}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, countries: [e.target.value] }))
              }
              className="input-sm half"
            >
              {countries.map((c) => (
                <option key={c.code} value={c.code}>
                  {c.name}
                </option>
              ))}
            </select>

            <select
              value={filters.dateRange}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, dateRange: e.target.value }))
              }
              className="input-sm half"
            >
              {dateOptions.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
          </div>

          {filters.dateRange === "range" && (
            <div className="input-row">
              <input
                type="date"
                value={filters.from || ""}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, from: e.target.value }))
                }
                className="input-sm full"
              />
              <input
                type="date"
                value={filters.to || ""}
                onChange={(e) =>
                  setFilters((prev) => ({ ...prev, to: e.target.value }))
                }
                className="input-sm full"
              />
            </div>
          )}

          <div className="input-row">
            <input
              type="text"
              placeholder="Add keyword"
              value={keywordInput}
              onChange={(e) => setKeywordInput(e.target.value)}
              className="input-sm flex full"
            />
          </div>

          <div className="input-row">
            <select
              value={filters.match}
              onChange={(e) =>
                setFilters((prev) => ({ ...prev, match: e.target.value }))
              }
              className="input-sm three-fifth"
            >
              {matchOptions.map(({ label, value }) => (
                <option key={value} value={value}>
                  {label}
                </option>
              ))}
            </select>
            <button onClick={addKeyword} className="btn add fifth">
              Add
            </button>
            <button
              onClick={() => {
                setFilters(defaultFilters);
                localStorage.removeItem("newsCompare:filters");
                localStorage.removeItem("newsCompare:articles");
              }}
              className="btn reset fifth"
            >
              Clear
            </button>
          </div>

          {filters.keywords.length > 0 && (
            <div className="keyword-list">
              {filters.keywords.map((kw, i) => (
                <span key={i} className="tag">
                  {kw}
                  <button
                    onClick={() => removeKeyword(kw)}
                    className="remove"
                  >
                    &times;
                  </button>
                </span>
              ))}
            </div>
          )}
        </>
      )}

      {/* Shared Buttons */}
      <div className="input-row">
        <button
          onClick={onSearch}
          className="btn find flex-1 flex items-center justify-center"
        >
          Find News
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className="h-4 w-4 mr-1"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="11" cy="11" r="7" />
            <line x1="16.65" y1="16.65" x2="21" y2="21" />
          </svg>
        </button>
      </div>
    </div>
  );
}
